import { createAction, props } from '@ngrx/store';

export const setOrganizationId = createAction(
  '[Log Forwarding] organization id',
  props<{ organizationId: number }>()
);
